export default __webpack_public_path__ + "c085a9f10e1a74d5cba3a8f0307769a4.jpg";